import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout.jsx";
import { useFetchAll } from "../../../../custom/FetchApiHook.jsx";
import BasicTable from "../../../../Components/CommonTable/BasicTable/BasicTable.jsx";
import { columns, searchBy } from "../../../../service/TaxMasterService.js";
import { MasterApi } from "../../../../App/api/setting.js";
import { useSelector } from "react-redux";
import AddTaxModal from "./AddTaxModal.jsx";
import { DeleteModal } from "../../../../custom/modal/delteModal.jsx";

const TaxMaster = ({meta}) => {
  const [addTaxModle, setAddTextModal] = useState(false);
  const [deleteTaxModle, setDeleteTextModal] = useState(false);
  const [selected, setSelectedData] = useState(null);
  const [taxDataClicked, setTaxDataClicked] = useState(null);
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });

  const { value: allTaxData, fetchAllData } = useFetchAll(() =>
    MasterApi.master.getAllTaxMaster(pagination, search)
  );
  const taxData = allTaxData?.data?.allTaxMaster;
  // console.log("all tax data:",taxData);
  
  const { data: countryData } = useSelector((state) => state.country);

  const countryFilter = countryData?.map((item) => {
    return { name: item?.name, code: item?._id };
  });

  const filters = [
    {
      filterType: "By Country",
      inputName: "order_type",
      options: countryFilter,
    },
  ];

  const handleFilter = (name, value) => {
    if (value.code === "asc" || value.code === "desc") {
      setPagination((prev) => ({
        ...prev,
        sortOrder: value.code,
      }));
    } else {
      setPagination((prev) => ({
        ...prev,
        filter: { country: value.code },
      }));
    }

    // console.log("e", value);
  };

  const handleClearFilter = () => {
    setPagination({
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    });
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  // console.log("Search ", search);
  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);

  const handleCellClicked = (row, action) => {
    // console.log("action", action);
    if (action) {
      setAddTextModal(true);
      setTaxDataClicked(row);
    } else {
      setTaxDataClicked(row);
      setDeleteTextModal(true);
    }
  };

  const handlePagination = (data) => {
    // console.log(data);

    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }
    setPagination((prev) => {
      let copyfilter = { ...prev.filter };
      if (data.filter) {
        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }
      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  const onPaginatorClick = (e) => {
    if (e) {
      // console.log("Paginator Clicked", e);
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  return (
    <div className="p-5">
      <CommonLayout />
      <BasicTable
        data={taxData}
        handleClearFilter={handleClearFilter}
        handleSearch={debouncedSearch}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: allTaxData?.data?.page || 1,
          rows: allTaxData?.data?.limit || 5,
          totalPages: allTaxData?.data?.totalPages || 1,
          totalCount: allTaxData?.data?.totalCount || 1,
        }}
        selectedData={setSelectedData}
        columns={columns}
        handleFilter={handleFilter}
        handleCellClick={handleCellClicked}
        SearchBy={searchBy}
        filters={filters}
        WeekRange={false}
        button_name="Add"
        handleButton={() => {
          setAddTextModal(true);
          setTaxDataClicked(null);
        }}
      />
      <AddTaxModal
        isOpen={addTaxModle}
        onClose={() => setAddTextModal(false)}
        data={taxDataClicked}
        fetchAllData={fetchAllData}
      />

      <DeleteModal
        isOpen={deleteTaxModle}
        handleClose={() => setDeleteTextModal(false)}
        fetchAllData={fetchAllData}
        data={taxDataClicked}
        title="Delete Tax"
        deleteApiFunction={MasterApi.master.delteTaxMaster}
        entityName="Tax Master"
      />
    </div>
  );
};

export default TaxMaster;
